const types = ['navigation', 'sidebar'];

types.forEach(type => {
    const trigger = document.getElementById(`canvas-${type}Trigger`);
    const content = document.getElementById(`canvas-${type}`);
    const closer = document.getElementById(`canvas-${type}Closer`);
    if (trigger && content && closer) {
        trigger.addEventListener('click', () => {
            content.focus();
            trigger.setAttribute("aria-expanded", "true");
            content.className += ' canvas-isOpen';
        });
        closer.addEventListener('click', () => {
            content.className = content.className.replace('canvas-isOpen', '').split('  ').join(' ');
            trigger.setAttribute("aria-expanded", "false");
        })
    }
})